/* LUV cart-sync : keeps the PagePilot bag bubble in sync after AJAX cart mutations.
   Listens for fetch & XHR requests to /cart/{add,change,update,clear}[.js] and
   dispatches a cart:update CustomEvent on document with the latest cart state.
   Debounced to avoid duplicate fetches when multiple handlers fire in the same tick. */
(function () {
  if (window.__luvCartSyncInstalled) return;
  window.__luvCartSyncInstalled = true;

  const CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(?:$|\?)/;
  const isCartUrl = (u) => {
    try { return CART_RE.test(typeof u === 'string' ? u : (u && u.url) || ''); } catch(e){ return false; }
  };

  let pending = null;
  function broadcast(source) {
    if (pending) return pending;
    pending = fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(r => r.json())
      .then(cart => {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: 'cart', sourceId: source || 'luv-cart-sync', data: cart }
        }));
      })
      .catch(() => {})
      .finally(() => { pending = null; });
    return pending;
  }

  // Wrap fetch
  const origFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    const cartReq = isCartUrl(input);
    const p = origFetch(input, init);
    if (cartReq) p.then(() => setTimeout(() => broadcast('fetch'), 0)).catch(() => {});
    return p;
  };

  // Wrap XHR (older code paths)
  const OrigXHR = window.XMLHttpRequest;
  if (OrigXHR) {
    const origOpen = OrigXHR.prototype.open;
    OrigXHR.prototype.open = function (method, url) {
      this.__luvCartUrl = url || '';
      return origOpen.apply(this, arguments);
    };
    const origSend = OrigXHR.prototype.send;
    OrigXHR.prototype.send = function () {
      if (isCartUrl(this.__luvCartUrl)) {
        this.addEventListener('load', () => setTimeout(() => broadcast('xhr'), 0));
      }
      return origSend.apply(this, arguments);
    };
  }
})();
